<template>
  <div>
    <div id="stackedBarApex"></div>
  </div>
</template>
<script>
export default {
  name: "StackedBarApex",
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods: {
    initChart() {
      var options = {
        series: [
          {
            name: "Nurse",
            data: [51, 54, 40, 67],
          },
          {
            name: "Doctor",
            data: [13, 22, 20, 8],
          },
          {
            name: "Technician",
            data: [15, 17, 15, 12],
          },
          {
            name: "Others",
            data: [21, 7, 25, 13],
          },
        ],
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: "end", // 'around', 'end'
            borderRadiusWhenStacked: "last", // 'all', 'last'
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        xaxis: {
          type: "datetime",
          categories: [
            "06/01/2025 GMT",
            "07/01/2025 GMT",
            "08/01/2025 GMT",
            "09/01/2025 GMT"
          ],
        },
        legend: {
          position: "right",
          offsetY: 40,
          show: false,
        },
        fill: {
          opacity: 1,
        },
      };

      var chart = new ApexCharts(
        document.querySelector("#stackedBarApex"),
        options
      );
      chart.render();
    },
  },
};
</script>
